import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Simple opacity+slide fade-up. No mask/overflow so text is never hidden
// if the IntersectionObserver misfires.
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <motion.span
    className={`block ${className}`}
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.span>
);

export const MaskLineInView = ({ children, delay = 0, className = "" }) => (
  <motion.span
    className={`block ${className}`}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.05 }}
    transition={{ duration: 0.85, ease: EASE, delay }}
  >
    {children}
  </motion.span>
);

export const FadeUp = ({ children, delay = 0, y = 30, className = "", as }) => {
  const Comp = motion[as || "div"];
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.05 }}
      transition={{ duration: 0.85, ease: EASE, delay }}
    >
      {children}
    </Comp>
  );
};
